import { css } from '@emotion/react'

// 스크롤바 숨기기
export const HideScrollBar = css`
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const HWAccelerator = css`
  transform: translateZ(0);
  will-change: transform;
`

/**
 * 인터넷에서 주움
 * https://codepen.io/siiron/pen/jfBhy
 */
export const LineClamp = (() => {
  const map = {}
  return (line: number, height?: number) => {
    const heightStyle = height
      ? `
      max-height: ${height * line}rem;
    `
      : `
      line-height: 1.1;
      max-height: ${1.1 * line - 0.1}em;
    `

    map[line] = map[line]
      ? map[line]
      : css`
          ${heightStyle};
          text-overflow: ellipsis;
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: ${line};
          -webkit-box-orient: vertical;
          overflow: hidden;
        `
    return map[line]
  }
})()
